/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#normalizeCancellationFeeCopy();
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  #normalizeCancellationFeeCopy() {
    const oldCopy = 'After custom work begins, a cancellation fee may apply.';
    const newCopy = 'After custom work begins, a cancellation fee of 15% of the product subtotal may apply.';

    this.querySelectorAll('p').forEach((paragraph) => {
      if (!paragraph.textContent?.includes(oldCopy)) return;

      paragraph.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE || !node.textContent?.includes(oldCopy)) return;
        node.textContent = node.textContent.replace(oldCopy, newCopy);
      });
    });
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
